import React, { useEffect, useState } from "react";
import {
  Input,
  DatePicker,
  Select,
  Button,
  message,
  Pagination,
  Spin,
  Empty,
  Drawer,
} from "antd";
import dayjs from "dayjs";
import { API_BASE_CRM_URL } from "../../Config/Config";
import { Footer } from "../footer/footer";
import Base from "../../Config/Base";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const { Search } = Input;
export default function Reminders({ customerId, relType }) {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [remindersData, setRemindersData] = useState([]);
  const [staffDropdownData, setStaffDropdownData] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [selectedStaffId, setSelectedStaffId] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("userDetails");

    if (storedUser) {
      const userDetails = JSON.parse(storedUser);

      setSelectedStaffId(userDetails?.staffid || null);
    }
  }, []);

  const [remindersSearchText, setRemindersSearchText] = useState("");

  const [remindersCurrentPage, setRemindersCurrentPage] = useState(1);

  const remindersPageSize = 6;

  const [addReminderModalOpen, setAddReminderModalOpen] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);

  const [addReminderData, setAddReminderData] = useState({
    description: "",
    date: null,
    staff: selectedStaffId,
    rel_type: "Lead",
    rel_id: null,
  });

  const [editReminderModalOpen, setEditReminderModalOpen] = useState(false);

  const [editReminderLoading, setEditReminderLoading] = useState(false);

  const [editReminderData, setEditReminderData] = useState({
    id: "",
    description: "",
    date: null,
    staff: selectedStaffId,
  });
  const [selectedRelType, setSelectedRelType] = useState("All");

  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [leadDropdown, setLeadDropdown] = useState([]);
  const [customerDropdown, setCustomerDropdown] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const fetchLeads = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}leads/GetLeads`);

      const data = await response.json();

      if (data.ResultData) {
        setLeadDropdown(data.ResultData);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      if (data.ResultData) {
        setCustomerDropdown(data.ResultData);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchStaffDropdown = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data.Status) {
        setStaffDropdownData(data.ResultData || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      let url = `${API_BASE_CRM_URL}reminder/GetReminders?staffid=0`;

      if (selectedRelType === "Lead" && selectedLead) {
        url += `&rel_id=${selectedLead}&rel_type=Lead`;
      }

      if (selectedRelType === "Customer" && selectedCustomer) {
        url += `&rel_id=${selectedCustomer}&rel_type=Customer`;
      }

      const response = await fetch(url);

      const data = await response.json();

      if (data.Status) {
        setRemindersData(data.ResultData);
      } else {
        setRemindersData([]);
      }
    } catch (err) {
      console.log(err);
      setRemindersData([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
    fetchCustomers();
    fetchStaffDropdown();
  }, []);

  useEffect(() => {
    fetchReminders();
  }, [selectedRelType, selectedLead, selectedCustomer, selectedStaffId]);

  const filteredReminders = remindersData.filter(
    (reminder) =>
      reminder.description
        ?.toLowerCase()
        .includes(remindersSearchText.toLowerCase()) ||
      `${reminder.firstname} ${reminder.lastname}`
        .toLowerCase()
        .includes(remindersSearchText.toLowerCase()),
  );

  const startIndex = (remindersCurrentPage - 1) * remindersPageSize;

  const paginatedReminders = filteredReminders.slice(
    startIndex,
    startIndex + remindersPageSize,
  );

  const handleAddReminder = async () => {
    if (!addReminderData.rel_id) {
      message.warning(`Please select a ${addReminderData.rel_type}.`);
      return;
    }
    try {
      setAddReminderLoading(true);

      const payload = {
        description: addReminderData.description,
        date: dayjs(addReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
        rel_id: addReminderData.rel_id,
        rel_type: addReminderData.rel_type,
        staff: addReminderData.staff,
        creator: selectedStaffId,
      };

      const response = await fetch(`${API_BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setAddReminderModalOpen(false);

        fetchReminders();

        setAddReminderData({
          description: "",
          date: null,
          staff: selectedStaffId,
          rel_type: "Lead",
          rel_id: null,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add reminder",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleUpdateReminder = async () => {
    try {
      setEditReminderLoading(true);

      const payload = {
        id: editReminderData.id,
        description: editReminderData.description,
        date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
        staff: editReminderData.staff,
      };

      const response = await fetch(
        `${API_BASE_CRM_URL}reminder/UpdateReminder`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setEditReminderModalOpen(false);

        fetchReminders();
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update reminder",
      });
    } finally {
      setEditReminderLoading(false);
    }
  };

  return (
    <Base>
      <div className="row">
        <div className="d-flex justify-content-between py-2 mb-3">
          <div className="page-title">
            <h4>FollowUp</h4>
            <h6>Manage your Follow Ups here</h6>
          </div>

          <div>
            <ul className="d-inline-flex list-unstyled gap-1 mb-0 justify-content-end">
              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="PDF"
                  // onClick={handlePDFDownload}
                  className="btn btn-light btn-sm px-0"
                >
                  <i
                    className="fa-solid fa-file-pdf fa-2xl"
                    style={{ color: "#ff0000" }}
                  ></i>
                </a>
              </li>

              <li>
                <a
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Excel"
                  // onClick={handleExcelDownload}
                  className="btn btn-light btn-sm"
                >
                  <i
                    className="fa-solid fa-file-excel fa-2xl"
                    style={{ color: "#217346" }}
                  ></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-12 d-flex align-items-center justify-content-between mb-2">
          <Search
            placeholder="Search reminders..."
            allowClear
            onChange={(e) => {
              setRemindersSearchText(e.target.value);
              setRemindersCurrentPage(1);
            }}
          />

          {/* <Select
            value={selectedStaffId}
            style={{ width: 250 }}
            onChange={(value) => setSelectedStaffId(value)}
            options={staffDropdownData.map((staff) => ({
              value: staff.staffid,
              label: `${staff.firstname} ${staff.lastname}`,
            }))}
          /> */}
          <button
            className="btn btn-sm btn-primary ms-2 mt-1"
            onClick={() => setAddReminderModalOpen(true)}
          >
            <i className="fa fa-solid fa-plus"></i>
          </button>
          <button
            className="btn btn-sm btn-secondary ms-2 mt-1"
            onClick={() => setShowFilters(!showFilters)}
          >
            <i className="fa fa-solid fa-filter"></i>
          </button>
        </div>
        <style>{`.filter-container {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
  transition:
    max-height 0.35s ease,
    opacity 0.3s ease,
    transform 0.3s ease,
    margin-top 0.3s ease;
}

.filter-container.show {
  max-height: 200px;
  opacity: 1;
  transform: translateY(0);
}`}</style>
      </div>
      <div className={`filter-container ${showFilters ? "show" : ""}`}>
        <div className="row g-2 mb-2">
          <div className="col-6">
            <Select
              className="w-100"
              value={selectedRelType}
              onChange={(value) => {
                setSelectedRelType(value);
                setSelectedLead(null);
                setSelectedCustomer(null);
              }}
              options={[
                { value: "All", label: "All" },
                { value: "Lead", label: "Lead" },
                { value: "Customer", label: "Customer" },
              ]}
            />
          </div>

          {selectedRelType === "Lead" && (
            <div className="col-6">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Lead"
                value={selectedLead}
                optionFilterProp="label"
                onChange={setSelectedLead}
                options={leadDropdown?.map((lead) => ({
                  value: lead.id,
                  label: `${lead.name} (${lead.company})`,
                }))}
              />
            </div>
          )}

          {selectedRelType === "Customer" && (
            <div className="col-6">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Customer"
                value={selectedCustomer}
                optionFilterProp="label"
                onChange={setSelectedCustomer}
                options={customerDropdown.map((customer) => ({
                  value: customer.customerId,
                  label: `${customer.company} (${customer.contactName})`,
                }))}
              />
            </div>
          )}
        </div>
      </div>
      {remindersLoading ? (
        <div className="text-center py-5">
          <Spin size="large" />
        </div>
      ) : (
        <>
          {!paginatedReminders.length ? (
            <Empty description="No Reminders Found" />
          ) : (
            <>
              <div className="row">
                {paginatedReminders.map((reminder) => (
                  <div className="col-12 col-md-6 col-lg-4 " key={reminder.id}>
                    <div className="card shadow-sm border-0">
                      <div className="card-body py-2">
                        <div className="d-flex justify-content-between align-items-start">
                          <div className="flex-grow-1">
                            <div
                              className="fw-semibold"
                              style={{
                                // maxWidth: "210px",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                              }}
                            >
                              <i className="fas fa-bell text-warning me-2"></i>
                              {reminder.description}
                            </div>

                            <div className="mt-1">
                              <small className="text-muted me-3">
                                <i className="fas fa-user me-1"></i>
                                {reminder.firstname} {reminder.lastname}
                              </small>

                              <small className="text-muted">
                                <i className="fas fa-calendar me-1"></i>
                                {dayjs(reminder.date).format("DD MMM YYYY")}
                              </small>
                            </div>
                          </div>

                          <i
                            className="fas fa-pen-to-square text-primary ms-2"
                            style={{
                              cursor: "pointer",
                              fontSize: "14px",
                            }}
                            onClick={() => {
                              setEditReminderData({
                                id: reminder.id,
                                description: reminder.description,
                                date: dayjs(reminder.date),
                                staff: reminder.staff,
                              });

                              setEditReminderModalOpen(true);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {filteredReminders.length > remindersPageSize && (
                <Pagination
                  className="mt-3 text-center"
                  current={remindersCurrentPage}
                  pageSize={remindersPageSize}
                  total={filteredReminders.length}
                  showSizeChanger={false}
                  onChange={(page) => setRemindersCurrentPage(page)}
                />
              )}
            </>
          )}
        </>
      )}

      <Drawer
        open={addReminderModalOpen}
        title={
          <>
            <i className="fas fa-bell me-2 text-warning"></i>
            Add Reminder
          </>
        }
        placement="bottom"
        height="45%"
        destroyOnClose
        onClose={() => setAddReminderModalOpen(false)}
      >
        <div className="row g-3">
          <div className="col-12">
            <Input.TextArea
              rows={4}
              placeholder="Enter reminder description"
              value={addReminderData.description}
              onChange={(e) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              value={addReminderData.rel_type}
              options={[
                {
                  value: "Lead",
                  label: "Lead",
                },
                {
                  value: "Customer",
                  label: "Customer",
                },
              ]}
              onChange={(value) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  rel_type: value,
                  rel_id: null,
                }))
              }
            />
          </div>
          {addReminderData.rel_type === "Lead" && (
            <div className="col-md-6">
              <Select
                showSearch
                size="large"
                className="w-100"
                placeholder="Select Lead"
                value={addReminderData.rel_id}
                optionFilterProp="label"
                options={leadDropdown.map((lead) => ({
                  value: lead.id,
                  label: `${lead.name} (${lead.company})`,
                }))}
                onChange={(value) =>
                  setAddReminderData((prev) => ({
                    ...prev,
                    rel_id: value,
                  }))
                }
              />
            </div>
          )}

          {addReminderData.rel_type === "Customer" && (
            <div className="col-md-6">
              <Select
                showSearch
                size="large"
                className="w-100"
                placeholder="Select Customer"
                value={addReminderData.rel_id}
                optionFilterProp="label"
                options={customerDropdown.map((customer) => ({
                  value: customer.customerId,
                  label: `${customer.company} (${customer.contactName})`,
                }))}
                onChange={(value) =>
                  setAddReminderData((prev) => ({
                    ...prev,
                    rel_id: value,
                  }))
                }
              />
            </div>
          )}
          <div className="col-md-6">
            <DatePicker
              showTime
              size="large"
              className="w-100"
              placeholder="Select Reminder Date"
              value={addReminderData.date}
              onChange={(value) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  date: value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              value={addReminderData.staff}
              placeholder="Select Staff"
              options={staffDropdownData.map((staff) => ({
                value: staff.staffid,
                label: `${staff.firstname} ${staff.lastname}`,
              }))}
              onChange={(value) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  staff: value,
                }))
              }
            />
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            type="primary"
            loading={addReminderLoading}
            onClick={handleAddReminder}
          >
            Add Reminder
          </Button>
        </div>
      </Drawer>

      <Drawer
        open={editReminderModalOpen}
        title={
          <>
            <i className="fas fa-pen-to-square me-2 text-primary"></i>
            Edit Reminder
          </>
        }
        placement="bottom"
        height="45%"
        destroyOnClose
        onClose={() => setEditReminderModalOpen(false)}
      >
        <div className="row g-3">
          <div className="col-12">
            <Input.TextArea
              rows={4}
              placeholder="Enter reminder description"
              value={editReminderData.description}
              onChange={(e) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <DatePicker
              showTime
              size="large"
              className="w-100"
              value={editReminderData.date}
              onChange={(value) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  date: value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              value={editReminderData.staff}
              options={staffDropdownData.map((staff) => ({
                value: staff.staffid,
                label: `${staff.firstname} ${staff.lastname}`,
              }))}
              onChange={(value) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  staff: value,
                }))
              }
            />
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4">
          <Button
            type="primary"
            loading={editReminderLoading}
            onClick={handleUpdateReminder}
          >
            Update
          </Button>
        </div>
      </Drawer>
      <Footer />
    </Base>
  );
}
